import script from "./LazyImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LazyImage.vue?vue&type=script&setup=true&lang=ts"

import "./LazyImage.vue?vue&type=style&index=0&id=3c08c0d5&lang=scss"

const __exports__ = script;

export default __exports__